/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_Form_HintInputs */

const vi_shop_category_form_hint = /** @type {(inputs: Shop_Category_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn Sửa một danh mục hoặc bấm Thêm danh mục.`)
};

/**

* @param {Shop_Category_Form_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_form_hint = /** @type {((inputs?: Shop_Category_Form_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_Form_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_form_hint(inputs)
});